<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="eventType==='view' ? null : dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col
                  v-if="eventType==='add'"
                  :span="6"
                >
                  <el-form-item
                    label="方案编号"
                    prop="schemeNo"
                  >
                    <el-input
                      v-model="dialogAddEditForm.schemeNo"
                      class="search_input"
                      disabled
                    />
                    <el-button
                      type="primary"
                      icon="el-icon-search"
                      class="search_button"
                      @click="showSearchProject"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-else
                  :span="6"
                >
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogAddEditForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogAddEditForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="物料名称">
                    <el-input
                      v-model="dialogAddEditForm.materialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="拜访报告抽查数量"
                    prop="reportAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditForm.reportAmount"
                      :min="0"
                      step-strictly
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="品鉴活动抽查数量"
                    prop="tasteAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditForm.tasteAmount"
                      :min="0"
                      step-strictly
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="品牌推广抽查数量"
                    prop="crossAmount"
                  >
                    <el-input-number
                      v-model="dialogAddEditForm.crossAmount"
                      :min="0"
                      step-strictly
                      :disabled="eventType==='view'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="抽样时间"
                    prop="testType"
                  >
                    <el-radio-group
                      v-model="dialogAddEditForm.testType"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        每周
                      </el-radio>
                      <el-radio :label="2">
                        活动结束
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div
              class="modal-row-box"
              style="padding-bottom:10px;"
            >
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 搜索方案 -->
    <search-project-dialog
      :dialog-visible.sync="dialogSearchProjectVisible"
      @choosedProject="choosedProjectFun"
    />
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 方案明细组件
import searchProjectDialog from './searchProjectDialog'
// 数据请求
import { saveOrUpdateCallBackBaseSettingApi, initCallBackBaseSettingApi } from '@/api/callBackBaseSetting'
export default {
  components: { searchProjectDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      loadingText: '努力加载数据中，请耐心等待',
      dialogAddEditForm: {
        schemeNo: '',
        schemeName: '',
        schemeId: '',
        materialsName: '',
        materialsId: '',
        reportAmount: 0,
        tasteAmount: 0,
        crossAmount: 0,
        testType: 1,
        remark: ''
      },
      dialogAddEditFormRules: {
        schemeNo: [{ required: true, message: '请选择方案', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      dialogSearchProjectVisible: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.dialogAddEditForm = {
          schemeNo: '',
          schemeName: '',
          schemeId: '',
          materialsName: '',
          materialsId: '',
          reportAmount: 0,
          tasteAmount: 0,
          crossAmount: 0,
          testType: 1,
          remark: ''
        }
        if (this.eventType === 'add') {
          this.loading = false
        } else {
          this.initPageData()
        }
      }
    }
  },
  methods: {
    // 查询方案
    showSearchProject() {
      this.dialogSearchProjectVisible = !this.dialogSearchProjectVisible
    },
    // 选择方案回调
    choosedProjectFun(row) {
      this.dialogAddEditForm.schemeNo = row.schemeNo
      this.dialogAddEditForm.schemeName = row.schemeName
      this.dialogAddEditForm.schemeId = row.schemeId
      this.dialogAddEditForm.materialsName = row.materialsName
      this.dialogAddEditForm.materialsId = row.materialsId
    },
    // 加载数据
    initPageData() {
      initCallBackBaseSettingApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditForm) {
          this.dialogAddEditForm[key] = data[key]
        }
        this.dialogAddEditForm.id = data.id
        this.loading = false
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '回访设置', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.loadingText = '正在处理数据中，请耐心等待'
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存操作
    saveOrUpdate() {
      saveOrUpdateCallBackBaseSettingApi(this.dialogAddEditForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
::v-deep .search_input.el-input--mini {
  width: 80%;
}
::v-deep .search_button.el-button--mini {
  float: right;
  display: inline-block;
  border-radius: 2px;
  padding: 7px 15px 6px;
}
</style>
